<template>
  <div></div>
</template>

<script>
export default {
  created () {
    const url = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`
    const redirectUrl = `${url}${this.$route.query.fullPath}`
    window.location.replace(`${window.baseConfig.loginServeUrl}?redirectUrl=${redirectUrl}`)
  }
}
</script>

<style>
</style>